module.exports = __webpack_public_path__ + "assets/arcadeweb4.jpg?189717fb1799b13dc84e36ce95de993e";